// @mui
import {
  Box,
  Container, Typography,
} from '@mui/material';
// routes
import { PATH_DASHBOARD } from 'src/routes/paths';
// hooks
import useSettings from 'src/hooks/useSettings';
// @types
// layouts
import Layout from 'src/layouts';
// components
import Page from 'src/components/Page';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
// sections
import { UserSetDialog } from 'src/sections/@dashboard/users';
import { useRouter } from 'next/router';
import { httpsCallable } from 'firebase/functions';
import { DB, FUNCTIONS } from 'src/contexts/FirebaseContext';
import { MyParsedURLQuery } from 'src/@types/@types';
import AuthGuard from 'src/guards/AuthGuard';
import { LoadingButton } from '@mui/lab';
import { useState } from 'react';
import Iconify from 'src/components/Iconify';

// ----------------------------------------------------------------------

const stripeOnboarding = httpsCallable(FUNCTIONS, 'api-https-stripe-stripeOnboarding');

// ----------------------------------------------------------------------

export default function SetupBrand() {
  const { themeStretch } = useSettings();

  const { query } = useRouter();
  const { brandID } = query as MyParsedURLQuery;

  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async() => {
    try {
      setIsLoading(true);
      // Get accountLink url from stripe
      const url = await stripeOnboarding({ brand_id: brandID, test: true }).then((res) => res.data as string);
      setIsLoading(true);
      // Go to url
      window.location.href = url;
    } catch (error) {
      console.log(error.message);
      setIsLoading(false);
    }
  }

  const ExternalLinkIcon = () => (
    <Iconify
      icon={'heroicons-outline:external-link'}
      sx={{ color: 'inherit', width: 20, height: 20 }}
    />
  );

  return (
    <Layout variant="overview">
      <Page title="Marke einrichten">
        <Container maxWidth={themeStretch ? false : 'lg'} sx={{ pt: 20, pb: 3 }}>
          <Box sx={{ display: 'flex', height: window.innerHeight / 2, justifyContent: 'center', alignItems: 'center' }}>
            <LoadingButton loading={isLoading} onClick={handleClick} variant="outlined" size="large" color="inherit" endIcon={<ExternalLinkIcon />}>
              Marke einrichten
            </LoadingButton>
          </Box>
        </Container>
      </Page>
    </Layout>
  );
}
